import React, { useState } from "react";
import PaginationNews from "../../../../components/Magazine/MagazineNewsDeployment/HeadlineNews/PaginationNews";
import { getAllRecordings } from "../../../../actions";
import useData from "../../../../hooks/useData";

//HOCs
import { withTopPaddingEnhanced } from "../../../../components/Hocs/withTopPadding";

const EnhancedBox = withTopPaddingEnhanced()();

const RecordingsPage = () => {
    const [itemsPerPage, setItemsPerPage] = useState(40);
    const [pageNumber, setPageNumber] = useState(1);
    const [paginationModel, setPaginationModel] = useState({
        page: pageNumber,
        pageSize: itemsPerPage,
    });

    const { data: newsRecordingsApiData } = useData(
        [
            "news-adders?filters[state]=aprobada&filters[news_adder_types][name]=Grabaciones",
            paginationModel,
        ],
        getAllRecordings,
    );

    return (
        <EnhancedBox
            sx={{
                gap: "20px",
                display: "flex",
                flexDirection: "column",
                padding: {
                    xl: "120px 5rem 40px 5rem",
                    lg: "120px 3.6rem 40px 3.6rem",
                    xs: "50px 1.5rem",
                },
            }}
        >
            <PaginationNews
                dataInformation={newsRecordingsApiData}
                setPageNumber={setPageNumber}
                pageNumber={pageNumber}
                setPaginationModel={setPaginationModel}
            />
        </EnhancedBox>
    );
};

export default RecordingsPage;
